import React from 'react';
import { LuSparkles } from 'react-icons/lu';
import { STRINGS } from '../../constants/strings';

/**
 * What the Ask Me page shows before the first question: a short explanation and the
 * ready-made questions (ASKME_COMMANDS) as tiles. Picking one opens its small form
 * (QuickCommandDialog) and puts the finished question in the box.
 */
const AskMeStart = ({ onPickCommand }) => {
  const commands = STRINGS.ASKME.COMMANDS;

  return (
    <div className="mx-auto w-full max-w-3xl px-6 py-10">
      <div className="mb-8 flex items-start gap-4">
        <div className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-ui-brand-soft text-brand-600 dark:text-brand-300">
          <LuSparkles aria-hidden className="size-5" />
        </div>
        <div>
          <h2 className="text-xl font-semibold tracking-tight text-ui-ink">What would you like to know?</h2>
          <p className="mt-1 text-sm leading-6 text-ui-ink-2">
            Type a question in plain words in the box below, for example “Show today’s attendance of class 8 B”.
            Or pick a ready-made question and fill in the class or exam.
          </p>
        </div>
      </div>

      <h3 className="mb-2 text-[11px] font-semibold tracking-wider text-ui-ink-3 uppercase">Ready-made questions</h3>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {commands.map((command) => (
          <button
            key={command.id}
            type="button"
            onClick={() => onPickCommand(command)}
            className="rounded-xl border border-ui-line bg-ui-card px-4 py-3 text-left shadow-card transition-colors hover:border-brand-300 hover:bg-ui-brand-soft dark:hover:border-brand-500/40"
          >
            <span className="block text-sm font-medium text-ui-ink">{command.title}</span>
            <span className="mt-0.5 block text-[13px] leading-snug text-ui-ink-2">{command.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AskMeStart;
